/**
 * @file: fuelType.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { AbstractSearchCriterionProvider } from '../AbstractSearchCriterionProvider';
import { SearchCriterionOption } from '../types';

const PrefinedFuelTypes: string[] = [
  '汽油',
  '柴油',
  '插电混合',
  '纯电动',
  '油电混合',
  '天然气 (CNG)',
  '汽油/甲醇',
  '甲醇',
  '增程式纯电动',
  '汽油CNG',
  '其他',
];

export class FuelTypeCriterion extends AbstractSearchCriterionProvider<'vehicleFuelType'> {
  static readonly shared = new FuelTypeCriterion();

  constructor() {
    super('vehicleFuelType');
  }

  getLabel(): string {
    return '燃油类型';
  }

  internalGetDisplayText(value: string): string {
    return value;
  }

  internalGetOptions(): SearchCriterionOption<string>[] {
    return PrefinedFuelTypes.map(value => ({ value }));
  }
}
